import api, { APIResponse } from '../../../lib/commons/api'
import { ProjectClosingStatusSearchParams } from '../ProjectClosingStatus/projectClosingStatus'
import {
  RequestStatus,
  User,
} from '../ProjectTaskActualWorkApprovalStatus/taskActualWorkApprovalStatus'
import { TaskActualWorkApprovalStatusSearchCondition } from './hooks/useSearchCondition'

export interface AllProjects {
  scheduledWorkingDays: number
  workingDays: number
  absences: number
  totalWorkingTime: number
  totalActualWorkingHour: number
  timeMismatchFlag: boolean
  missingTaskActualWorkFlag: boolean
  missingActualWorkingHourFlag: boolean
  requestStatus: RequestStatus
  unRequestedHour: number
  requestedHour: number
}

export interface TaskActualWorkApprovalStatusTenantResponse {
  user: User
  allProjects: AllProjects
  approvedHour: number
  unapprovedHour: number
}

export interface TaskActualWorkApprovalStatusRow {
  uuid?: string
  companyName?: string
  division?: string
  position: string
  businessPartner?: boolean
  userName: string
  userIconUrl?: string
  discrepancyBetweenActualWorkingHourAndTaskActualWork?: boolean
  discrepancyActualWorkingHour?: boolean
  discrepancyTaskActualWork?: boolean
  requestStatus: RequestStatus
  // All Projects Info
  scheduledWorkingDays?: number
  absences?: number
  workingDays?: number
  totalWorkingTime?: number
  totalActualWorkingHour?: number
  requestedHour?: number
  unRequestedHour?: number
  approvedHour?: number
  unApprovedHour?: number
}

export const fetchAll = async (
  startDate: string,
  endDate: string,
  searchCondition?: TaskActualWorkApprovalStatusSearchCondition
): Promise<APIResponse> => {
  const params: ProjectClosingStatusSearchParams = {
    startDate: startDate,
    endDate: endDate,
    ...searchCondition,
  }
  return api.functional.request(
    'GET',
    '/api/v1/task_actual_work_approval_status',
    params
  )
}

export const fetchCount = async (
  startDate: string,
  endDate: string,
  searchCondition?: TaskActualWorkApprovalStatusSearchCondition
): Promise<APIResponse> => {
  const params: ProjectClosingStatusSearchParams = {
    startDate: startDate,
    endDate: endDate,
    ...searchCondition,
  }
  return api.functional.request(
    'GET',
    '/api/v1/task_actual_work_approval_status/count',
    params
  )
}

export { RequestStatus }
